<template>
  <div class="documento-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Gestión de Documentación</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30">mdi-file-document-multiple-outline</v-icon>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 content-area bg-light">
            
            <div v-if="!documentos || documentos.length === 0" class="text-center pa-10 bg-light-gradient rounded-xl">
              <v-icon size="64" color="grey lighten-2">mdi-check-all</v-icon>
              <h3 class="text-h6 grey--text text--darken-1 mt-4">Todo al día</h3>
              <p class="text-body-2 grey--text">No tienes documentos faltantes por entregar.</p>
            </div>

            <v-row v-else>
              <v-col cols="12" md="6" lg="6" v-for="(element, index) in documentos" :key="index">
                <v-card class="rounded-xl border-light hover-card h-100 d-flex flex-column" elevation="0">
                  <div class="pa-4 flex-grow-1">
                    <div class="d-flex justify-space-between align-start mb-2">
                      <div class="d-flex gap-2">
                        <v-chip
                          small
                          :color="element.entregado ? 'success lighten-5' : 'error lighten-5'"
                          :text-color="element.entregado ? 'success darken-1' : 'error darken-1'"
                          class="font-weight-bold mr-2"
                        >
                          <v-icon left small v-if="element.entregado">mdi-check-circle</v-icon>
                          <v-icon left small v-else>mdi-alert-circle</v-icon>
                          {{ element.entregado ? 'Entregado' : 'Faltante' }}
                        </v-chip>
                        
                        <v-chip
                          v-if="element.entregado && element.validado"
                          small
                          color="info lighten-5"
                          text-color="info darken-2"
                          class="font-weight-bold"
                        >
                          <v-icon left small>mdi-shield-check</v-icon>
                          Validado
                        </v-chip>
                      </div>
                    </div>
                    
                    <h3 class="text-subtitle-1 font-weight-bold primary-text line-height-1 mt-3 mb-2">
                      <template v-if="element.id != 50">{{ element.documento }}</template>
                      <router-link v-else to="/contactoDatos" class="text-decoration-none primary--text">
                        {{ element.documento }} <v-icon small color="primary">mdi-open-in-new</v-icon>
                      </router-link>
                    </h3>
                  </div>

                  <!-- Actions Footer -->
                  <div class="px-4 py-3 bg-light border-top mt-auto">
                    <!-- Ya Validado -->
                    <div v-if="element.entregado && element.validado" class="text-center text-caption success--text text--darken-1 py-1 font-weight-bold">
                      <v-icon small color="success">mdi-check-all</v-icon> Documento aceptado y archivado
                    </div>

                    <!-- Archivos subidos pero no validados -->
                    <div v-if="element.documentos && element.documentos.length > 0 && !element.validado && element.id != 50" class="d-flex flex-column gap-2">
                      <div v-for="(docElement, docIndex) in element.documentos" :key="docIndex" class="d-flex align-center justify-space-between bg-white rounded-lg pa-2 border-light mb-2">
                        <span class="text-caption font-weight-bold grey--text text--darken-2">
                          <v-icon small color="grey" class="mr-1">mdi-file</v-icon> Archivo {{ docIndex + 1 }}
                        </span>
                        <div>
                          <v-btn icon small color="primary" class="glass-btn mr-1" :href="docElement.documento_imagen.imagen" target="_blank" title="Ver">
                            <v-icon small>mdi-eye</v-icon>
                          </v-btn>
                          <v-btn icon small color="info" class="glass-btn mr-1" @click="uploadFile(docElement.documento_completo.IDF)" title="Modificar">
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon small color="error" class="glass-btn" @click="deleteDocumento(docElement.documento_imagen.IDVReg)" title="Eliminar">
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>

                    <!-- Botón para subir (si faltan) -->
                    <div v-if="element.documentos && element.documentos.length < 2 && !element.validado && element.id != 10 && element.id != 6 && element.id != 50" class="mt-2">
                      <v-btn
                        v-for="btnElement in docCount(element.documentos)"
                        :key="'upload-' + btnElement"
                        small
                        block
                        color="primary"
                        outlined
                        rounded
                        class="mb-2 border-dashed"
                        @click="uploadFile(element.documento_completo.IDF)"
                      >
                        <v-icon left small>mdi-cloud-upload</v-icon> Subir Documento
                      </v-btn>
                    </div>

                    <div v-if="(!element.documentos || element.documentos.length === 0) && element.id == 50" class="text-center text-caption grey--text py-1">
                      <v-icon small color="grey lighten-1">mdi-information-outline</v-icon> Complete los datos en el enlace
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            
          </div>
        </v-card>
      </v-col>
      <input id="file-upload" type="file" v-on:change="addDocument()" ref="fileInput" class="d-none" />
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Documento",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title:"Documentos faltantes",
    selected:'',
    documentos:[],  
  }),

  methods: {
    async uploadFile(tipo_documento_id) {
      this.selected = tipo_documento_id;     
      this.$refs.fileInput.click();
    },

    docTitle(index){
      return "Documento " + (index+1);
    },

    docCount(docList){
      if(!docList) return 2;
      return 2 - docList.length;
    },

    async addDocument() {
      if(!this.$refs.fileInput.files[0]) return;
      var formData = new FormData();
      formData.append('tipo_documento_id', this.selected);
      formData.append('image', this.$refs.fileInput.files[0]);

      let url = "alumno-documentos/upload";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.$refs.fileInput.value = null;
          this.loadDocumentos();
        });
    },

    async deleteDocumento(id) {
      if(confirm('¿Estás seguro de eliminar este documento?')){
        let url = "alumno-documentos/delete/" + id;
        await this.$API
          .post({
            url: url,
          }).then(() => {
            this.loadDocumentos();
          });
      }
    },
    async loadDocumentos() {
      let url = "documentos/index";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.documentos = res.documentos;
        });
    }
  },

  mounted() {
    if(this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true || this.$store.getters.user.excedente){
      this.$router.push({
          name: "Home"
        });
    }
    this.loadDocumentos();
  },
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.documento-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-top { border-top: 1px solid rgba(0, 0, 0, 0.05); }
.border-dashed { border-style: dashed !important; border-width: 2px !important; opacity: 0.7; }
.border-dashed:hover { opacity: 1; }

.hover-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.hover-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.15) !important;
}

.gap-2 { gap: 8px; }

.line-height-1 { line-height: 1.2; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
